class ProductConfigurator extends HTMLElement {
  constructor() {
    super();
    this.getOptions = this.querySelectorAll('.product-configurator__option');
    this.getDiscountOptions = this.querySelector('.product-configurator__options-discount');
    this.removeDiscountButtons = this.querySelectorAll('.product-configurator__remove-discount');
    this.getVariants = this.querySelectorAll('.product-configurator__variant');
    this.variantWrapper = this.querySelectorAll('.product-configurator__variants-wrap');
    this.counter = this.querySelector('.product-configurator__counter');
    this.unpickedImage = this.querySelector('.product-configurator__option-img').src;
    this.titles = this.querySelectorAll('.product-configurator__title');
    this.optionTitles = this.querySelectorAll('.product-configurator__option-title');

    this.cartDrawerOpenBtn = document.querySelector('.site-nav__link.site-nav__link--icon.js-drawer-open-cart');
    this.addButton = document.querySelector('.add-to-cart');
    this.price = document.querySelector('[data-product-price]');
    this.comparePrices = document.querySelectorAll('[data-compare-price]');

    this.variantsDataJson = JSON.parse(document.querySelector('#variantsDataJson').textContent)

    this.optionIndex = 0;
    this.optionQuantity = this.getOptions.length;
    this.discountQuantity = this.getDiscountOptions ? this.getDiscountOptions.children.length : 0;

    this.variantTag = [0, 0];
    this.pickedId = null;

    this.disabledButtons();


    this.setOption();
    this.removeOption();

    this.addButton.addEventListener('click', async (e) => {
      e.preventDefault();
      if (this.addButton.getAttribute('aria-disabled') == 'false') {
        this.sendProductVariants();
      } else {
        this.variantWrapper[0].setAttribute('data-show', 'true');
      }
    }, true);

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target) && this.addButton.getAttribute('aria-disabled') == 'false') {
        this.variantWrapper[0].setAttribute('data-show', 'false');
        this.variantWrapper[1]?.setAttribute('data-show', 'false');
        this.setAttribute('data-show', 'false');
      }
    })
  }

  setOption() {
    this.getOptions.forEach((option, index) => {
      option.addEventListener('click', (e) => {
        this.changeVariant(option, index);
        this.removeVariant(option, index);
        this.getOptionQuantity();
        this.getPickedVariant();
        this.setActiveProductsBundle(option, index);
        this.setBorder();
      });
    });
    this.pickVariant();
  }

  removeOption() {
    this.removeDiscountButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();

        if (+btn.parentElement.dataset.index == this.optionQuantity - 1) {
          this.removeVariant(btn.parentElement, +btn.parentElement.dataset.index);
          this.getOptionQuantity();
          this.getPickedVariant();
          this.setActiveProductsBundle();
          this.getOptions.forEach(o => o.setAttribute('data-border', 'false'));
          this.getOptions[this.checkEmptyOption()].setAttribute('data-border', 'true');
        } else {
          btn.parentElement.setAttribute('data-discount', 'false');
          this.removeVariant(btn.parentElement, +btn.parentElement.dataset.index)
          this.getOptionQuantity();
          this.getPickedVariant();
          this.setActiveProductsBundle();
        }

        if (+this.counter.dataset.quantity == this.optionQuantity - this.discountQuantity) {
          [...this.getDiscountOptions.children].forEach(o => {
            o.setAttribute('data-discount', 'false')
          });
          this.getOptions.forEach(o => o.setAttribute('data-border', 'false'));
          [...this.getDiscountOptions.children][0].setAttribute('data-discount', 'true');

          this.getOptions[this.checkEmptyOption()].setAttribute('data-border', 'true');
        }

        this.variantWrapper[0].setAttribute('data-show', 'false');
        this.setAttribute('data-show', 'false');
      })
    });

  }

  pickVariant() {
    this.getVariants.forEach(variant => {
      variant.addEventListener('click', (e) => {
        if (variant.getAttribute('data-disabled') == 'false' && +this.counter.dataset.quantity < this.optionQuantity) {
          this.optionIndex = this.checkEmptyOption();
          this.getOptions[this.optionIndex].firstElementChild.src = variant.firstElementChild.src;
          let title = variant.getAttribute('data-title');
          let sku = variant.getAttribute('data-sku');
          let expensive = variant.getAttribute('data-expensive');

          this.getOptions[this.optionIndex].setAttribute('data-title', title);
          this.getOptions[this.optionIndex].setAttribute('data-sku', sku);
          this.getOptions[this.optionIndex].setAttribute('data-expensive', expensive);

          this.getOptions[this.optionIndex].setAttribute('data-checked', 'true');
          this.getOptionQuantity();
          this.optionIndex++;
          this.setIndexRange();
          this.setBorder(e, null);
          this.getPickedVariant();
          this.setActiveProductsBundle();
        }
        this.setCheckMark(variant);
      })
    })
  }

  checkEmptyOption() {
    let emptyIndex = 0;
    [...this.getOptions].some((option, index) => {
      if (option.getAttribute('data-checked') === 'false') {
        emptyIndex = index;
        return true;
      }
      return false;
    });
    return emptyIndex;
  }

  setIndexRange() {
    if (this.optionIndex == this.optionQuantity) {
      this.optionIndex = this.optionQuantity - 1;
    }
    if (this.optionIndex <= 0) {
      this.optionIndex = 0;
    }
  }

  changeVariant(option, index) {
    let image = option.querySelector('img');
    if (option.getAttribute('data-checked') == 'true' && +this.counter.dataset.quantity == (this.optionQuantity - this.discountQuantity)) {
      this.optionIndex = index;
      this.counter.dataset.quantity = this.optionQuantity - 1;
      image.src = this.unpickedImage;
      option.setAttribute('data-checked', 'false');
      option.removeAttribute('data-title');
      option.removeAttribute('data-sku');
      this.disabledButtons();
      this.getPickedVariant();
    }
  }

  removeVariant(option, index) {
    let image = option.querySelector('img');
    if (+this.counter.dataset.quantity <= this.optionQuantity && option.getAttribute('data-checked') == 'true') {
      this.optionIndex = index;
      +this.counter.dataset.quantity--;
      image.src = this.unpickedImage;
      option.setAttribute('data-checked', 'false');
      option.removeAttribute('data-title');
      option.removeAttribute('data-sku');
      this.getPickedVariant();
    }
  }

  setBorder() {
    if (this.getOptions[this.checkEmptyOption()].getAttribute('data-checked') == "false" && this.getOptions[this.optionIndex].getAttribute('data-border') == "false") {
      this.getOptions.forEach(o => o.setAttribute('data-border', 'false'));
      this.getOptions[this.checkEmptyOption()].setAttribute('data-border', 'true');
      this.getOptions[this.checkEmptyOption()].setAttribute('data-discount', 'true');
    }
  }

  getOptionQuantity() {
    let quantity = 0;
    this.querySelectorAll('.product-configurator__option').forEach(option => {
      if (option.getAttribute('data-checked') === 'true') {
        quantity++;
      }
    });

    this.counter.dataset.quantity = quantity;
    if (quantity == (this.optionQuantity - this.discountQuantity)) {
      this.enabledButtons();
    }

    if (quantity == this.optionQuantity) {
      this.getOptions.forEach(o => o.setAttribute('data-border', 'false'));
      this.variantWrapper[0].setAttribute('data-show', 'false');
      this.variantWrapper[1]?.setAttribute('data-show', 'false');
      this.setAttribute('data-show', 'false');
    }
  }

  async sendProductVariants() {
    const variants = [];
    const skues = [];

    this.getOptions.forEach(option => {
      const { title, sku } = option.dataset;
      if (title) {
        variants.push(title);
        skues.push(sku);
      }
    });

    await this.addVariants(variants, skues);
  }


  async render() {
    const newHTML = await this.fetchSection();
    const parser = new DOMParser();
    let resAsHtml = parser.parseFromString(newHTML, 'text/html');

    const updatedCart = resAsHtml.querySelector('#CartDrawer');
    const currentContent = document.querySelector('.drawer__inner');
    const newContent = updatedCart.querySelector('.drawer__inner');

    if (currentContent.innerHTML === newContent.innerHTML) {
      return;
    } else {
      currentContent.innerHTML = newContent.innerHTML;
    }

    const size = document.querySelector('.cart__items').getAttribute('data-count');
    if (size == 0) {
      document.querySelector('#CartDrawer').classList.add('is-empty');
      document.querySelector('.cart-link__bubble').classList.remove('cart-link__bubble--visible');
    } else {
      document.querySelector('#CartDrawer').classList.remove('is-empty');
      document.querySelector('.cart-link__bubble').classList.add('cart-link__bubble--visible');
    }
  }

  async fetchSection() {
    const res = await fetch(
      window.Shopify.routes.root + '?section_id=header');
    const text = await res.text();
    return text;
  }

  async addVariants(variants, skues) {
    const formData = {
      items: [{
        id: this.pickedId,
        quantity: 1,
        properties: {
          "Varianten": variants.join(', '),
          "_Artikelnummern": skues.join(', ')
        }
      }]
    };

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const data = await response.json();
      await this.render();
      this.cartDrawerOpenBtn.click();
      console.log(data);
    } catch (error) {
      console.error('Error:', error);
    }
  }


  getPickedVariant() {
    let quantity = 0;
    this.counter.dataset.quantity;
    this.getOptions.forEach((option, index) => {
      if (option.hasAttribute('data-option') && option.dataset.checked == 'true') {
        quantity++;
      }
    });
    if (+this.counter.dataset.quantity >= this.optionQuantity - this.discountQuantity) {
      this.counter.textContent = this.counter.dataset.quantity;
      this.counter.nextElementSibling.textContent = `von ${this.counter.dataset.quantity} ausgewählt`
    } else {
      this.counter.textContent = quantity;
      this.counter.nextElementSibling.textContent = `von ${this.dataset.size} ausgewählt`
    }

    this.setDataFromJSON();
  }

  setDataFromJSON() {
    let expensiveCount = 0;

    // Calculate expensive count and update variant tag
    this.getOptions.forEach(option => {
      const { title, expensive } = option.dataset;
      if (title) {
        if (expensive === 'true') expensiveCount++;
        this.updateVariantTag();
      }
    });

    this.variantTag[1] = expensiveCount;
    const variantKey = this.variantTag.join('');

    const selectedVariant = this.findSelectedVariant(variantKey);
    if (selectedVariant) {
      this.updateData(selectedVariant);
    }
  }

  updateVariantTag() {
    const currentQuantity = +this.counter.dataset.quantity;
    const thresholdQuantity = this.optionQuantity - this.discountQuantity;
    this.variantTag[0] = currentQuantity >= thresholdQuantity ? currentQuantity : thresholdQuantity;
  }

  findSelectedVariant(variantKey) {
    return this.variantsDataJson.find(variant => {
      const strippedTitle = variant.title.replace(/\D/g, '');
      if (strippedTitle.length > 1) {
        return strippedTitle === variantKey;
      }
      return strippedTitle === variantKey[0];
    });
  }

  updateData(selectedVariant) {
    console.log(selectedVariant);
    this.pickedId = selectedVariant.id;
    this.price.textContent = this.formatMoney(selectedVariant.price);
    this.comparePrices.forEach(comparePrice => {
      comparePrice.textContent = this.formatMoney(selectedVariant.compare_at_price);
    });
  }


  formatMoney(price) {
    return "€" + (price / 100).toFixed(2).replace(".", ",").replace(",00", "");
  }

  disabledButtons() {
    this.addButton.setAttribute('aria-disabled', 'true');
    this.addButton.parentElement.setAttribute('aria-disabled', 'true');
  }

  enabledButtons() {
    this.addButton.setAttribute('aria-disabled', 'false');
    this.addButton.parentElement.setAttribute('aria-disabled', 'false');
  }

  setActiveProductsBundle(option, index) {
    let currentIndex = +option?.dataset.index;
    if (this.variantWrapper.length > 1) {
      if (currentIndex < 2) {
        this.variantWrapper[0].setAttribute('data-show', 'true');
        this.variantWrapper[1].setAttribute('data-show', 'false');
        this.setAttribute('data-show', 'true');
        this.setAttribute('data-show', 'true');
        this.titles[0].setAttribute('data-show', 'true');
        this.titles[1].setAttribute('data-show', 'false');
      } else {
        if (+this.counter.dataset.quantity > 1) {
          this.variantWrapper[0].setAttribute('data-show', 'false');
          this.variantWrapper[1].setAttribute('data-show', 'true');
          this.setAttribute('data-show', 'true');
          this.titles[0].setAttribute('data-show', 'false');
          this.titles[1].setAttribute('data-show', 'true');
        } else {
          this.variantWrapper[0].setAttribute('data-show', 'true');
          this.variantWrapper[1].setAttribute('data-show', 'false');
          this.setAttribute('data-show', 'true');
          this.titles[0].setAttribute('data-show', 'true');
          this.titles[1].setAttribute('data-show', 'false');
        }
      }

    } else {
      if (+this.counter.dataset.quantity >= this.optionQuantity - this.discountQuantity) {
        if (this.variantWrapper[0].dataset.show == 'false') {
          if (+this.counter.dataset.quantity == this.optionQuantity) {
            this.variantWrapper[0].setAttribute('data-show', 'false');
            this.setAttribute('data-show', 'false');
          } else {
            this.variantWrapper[0].setAttribute('data-show', 'true');
            this.setAttribute('data-show', 'true');
          }
        } else {
          this.variantWrapper[0].setAttribute('data-show', 'false');
          this.setAttribute('data-show', 'false');

        }
      } else {
        this.variantWrapper[0].setAttribute('data-show', 'true');
        this.setAttribute('data-show', 'true');
      }
    }
  }

  setCheckMark(variant) {
    const wrapper = variant.closest('.product-configurator__variants-wrap');
    const markTimeout = parseInt(variant.dataset.time) * 1000;

    this.getVariants.forEach(v => v.removeAttribute('data-mark'));

    if (wrapper.dataset.show !== "false") {
      variant.setAttribute('data-mark', '');
      setTimeout(() => variant.removeAttribute('data-mark'), markTimeout);
    }
  }

}

customElements.define('product-configurator', ProductConfigurator);